import { Component, Input } from '@angular/core';
import { AlertType } from 'src/app/core/enums/enums';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  @Input() type: string;
  @Input() hasIcon = true;
  @Input() footer = false;
  @Input() description = true;

  alertType = AlertType;

  constructor() {}
}
